$(document).ready(function () {
  $('.banner-sliders').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    autoplay: true,
    nextArrow: '.next-slider',
    prevArrow: '.prev-slider',
    dots: true, responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
        }
      },
      // {
      //   breakpoint: 600,
      //   settings: {
      //     slidesToShow: 2,
      //     slidesToScroll: 2
      //   }
      // },
      // {
      //   breakpoint: 480,
      //   settings: {
      //     slidesToShow: 1,
      //     slidesToScroll: 1
      //   }
      // }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
});